import { action as apiAction } from 'api/Api'
import {
  add as addSubCardGroup
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  name: string
  position?: number
}

export default (payload: Payload) => async dispatch => {
  const { cardId, name, position } = payload

  const tempId = `temp-${new Date().getTime()}`

  const optimisticAction = optimisticDispatch(dispatch, addSubCardGroup({
    cardId,
    element: {
      id: tempId,
      elementName: '/Data/SubCardGroup',
      name: name.trim(),
      items: [],
      isBusy: true,
      index: position
    }
  }))

  try {
    await apiAction('AddSubCardGroup', {
      cardId,
      name: name.trim(),
      position
    })
  } finally {
    optimisticAction.revert()
  }
}
